import { render, staticRenderFns } from "./LandingHeader.vue?vue&type=template&id=234771f4&scoped=true"
import script from "./LandingHeader.vue?vue&type=script&lang=js"
export * from "./LandingHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234771f4",
  null
  
)

export default component.exports